// ----------------------------------------------------------------------------
// Snippet: Shopify Predictive Search
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_predictive-search.scss';

const SEARCH_FORM = '.search-box';
const PREDICTIVE_SEARCH= '.predictive-search';

document.body.addEventListener('click', function(event) {

    const element = event.target;

    if (element.closest(SEARCH_FORM) == null) {
        const predictiveSearchResults = document.querySelectorAll(PREDICTIVE_SEARCH);
        predictiveSearchResults.forEach((predictiveSearchResult) => {
            predictiveSearchResult.style.display = 'none';
        });
    }
});
